<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r mb-2">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <div class="text-xs-left f-20">Chats</div>
      </v-toolbar>
    </v-card>
        <v-layout row wrap class="text-xs-center">
          <v-flex lg4 sm6 xs12>
            <v-card class="card-r shadow-1 white pa-2">
                  <v-toolbar flat class=" white text-xs-center" dark xs12>
                    <router-link v-show="!show" to="/" class="no-deraction pl-3">
                      <v-icon class="grey--text pt-2">fas fa-arrow-left</v-icon>
                    </router-link>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                      <div v-show="!show" class="pl-5 grey--text text-xs-center font-weight-bold f-15">Users list</div>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
                          <v-btn flat icon v-show="!show" v-on:click='show = !show' icon large class="ma-0 no-shadow">
                            <v-icon class="grey--text">search</v-icon>
                          </v-btn>
                        <v-container v-show="show" class="pt-0 pb-0">
                          <v-layout wrap row >
                            <v-flex xs10 lg11 class="text-xs-right">
                              <div v-show="show">
                                <v-flex xs12 class="white hide-pro pro">
                                  <v-text-field class="pa-0"
                                      background-color="grey lighten-4"
                                      prepend-inner-icon="search"
                                                light
                                      label="Search"
                                      solo
                                  ></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs2 lg1 class="text-xs-right">
                              <div v-show="show">
                                <v-btn large icon flat class="ma-0" v-show="show" v-on:click='show = !show'>
                                  <v-icon class="grey--text font-weight-bold f-35">close</v-icon>
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>

                  </v-toolbar>
                <v-layout style="height: 66vh;overflow: scroll;" row class="">
                  <v-flex xs12 sm12>
                    <v-card class="no-shadow mb-5" fill-height>
                      <v-list subheader class="white pa-0 ma-0">
                        <v-subheader @click="seen = false">Recent chat</v-subheader>
                        <div class="pa-0"
                          @click="GetChats('chat',item)"
                          v-for="item in chatList"
                          :key="item.id"
                          avatar>
                          <v-list-tile avatar class="w-100 ma-0 pa-0" @click="seen = true">

                          <v-list-tile-avatar>
                            <img class="objec-fit" v-if="item.type=='receive'" :src="item.sender.image">
                            <!-- <v-badge color="red" class="hidden-xs-only">
                                <span class="v-badge__badge">0</span>
                            </v-badge> -->

                            <img class="objec-fit" v-if="item.type=='send'" :src="item.receiver.image">
                            <v-badge color="red" class="hidden-xs-only" v-if="item.unseen_message_count!=0">
                                <span class="v-badge__badge">{{item.unseen_message_count}}</span>
                            </v-badge>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-if="item.type=='receive'" v-html="item.sender.name" class="f-15 text-capitalize"></v-list-tile-title>
                            <v-list-tile-title v-if="item.type=='send'" v-html="item.receiver.name" class="f-15 text-capitalize"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.sub"></v-list-tile-sub-title>
                          </v-list-tile-content>

                            <v-list-tile-action v-if="item.receiver">
                              <v-icon class="f-12" :color="item.receiver.lastSeenAgo=='Active now' ? 'green' : 'grey'">fas fa-circle</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-action v-if="item.sender">
                              <v-icon class="f-12" :color="item.sender.lastSeenAgo=='Active now' ? 'green' : 'grey'">fas fa-circle</v-icon>
                            </v-list-tile-action>

                          </v-list-tile>
                        </div>
                      </v-list>

                      <v-divider></v-divider>

                      <v-list subheader class="white">
                        <v-subheader>Previous chats</v-subheader>

                        <div
                          @click="GetChats('contact',item)"
                          v-for="item in contactsList"
                          :key="item.id"
                          avatar
                        >
                          <v-list-tile avatar class="w-100 ma-0 pa-0" @click="seen = true">

                          <v-list-tile-avatar>
                            <img class="objec-fit" :src="item.image">
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title v-html="item.name" class="f-15 text-capitalize"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.sub"></v-list-tile-sub-title>
                          </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon class="f-12" :color="item.active ? 'green' : 'grey'">fas fa-circle</v-icon>
                            </v-list-tile-action>

                          </v-list-tile>
                        </div>
                      </v-list>
                    </v-card>
                  </v-flex>
                </v-layout>
            </v-card>
          </v-flex>
          <v-flex  lg8 sm6 xs12>
            <img style="height: 76vh;overflow: scroll;" v-show="!seen" class="w-100 objec-fit" src="../../../static/chatb.png"/>

            <v-card v-show="seen" class="card-r grey lighten-4 no-shadow white--text topborder" flat xs12 sm6>
              <div class="StudentHome" xs12>
                <div>
                  <v-toolbar flat class="card-r grey lighten-5 text-xs-center" dark xs12>
                    <!-- <router-link to="`#/ClassFilter`" class="no-deraction pl-2">
                      <v-icon class="grey--text pt-2">fas fa-arrow-left</v-icon>
                    </router-link> -->
                    <v-spacer></v-spacer>
                    <v-toolbar-title v-show="!findtext">
                      <div class="pl-5 grey--text text-xs-center font-weight-bold f-17 text-capitalize">{{selectedUserName}}</div>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
                    <v-btn flat icon v-show="!findtext" v-on:click='findtext = !findtext' icon large class=" no-shadow">
                      <v-icon class="grey--text">search</v-icon>
                    </v-btn>
                    <v-container v-show="findtext" class="pt-0 pr-0">
                      <v-layout wrap row >
                        <v-flex xs10 lg11 class="text-xs-right pa-2 pro hide-pro">
                          <div v-show="findtext">
                            <v-flex xs12 class="">
                              <v-text-field class="pa-0"
                                            background-color="white"
                                            light
                                            prepend-inner-icon="search"
                                            label="Find Text"
                                            single-line
                                            solo
                              ></v-text-field>
                            </v-flex>
                          </div>
                        </v-flex>
                        <v-flex xs2 lg1 class="text-xs-right">
                          <div v-show="findtext" class="right mr-2 mt-1">
                            <v-btn small icon flat class="right" v-show="findtext" v-on:click='findtext = !findtext'>
                              <v-icon class="grey--text font-weight-bold f-35">close</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-toolbar>
                </div>
                <v-container style="height: 54vh;overflow: scroll;" fluid grid-list-xl class="pa-0">
                  <v-layout column class=" mb-2 pa-2 text-xs-right" >
                    <div class="w-100" v-for="messages in selectedUserMessages">
                      <div class="w-100 f-12 pa-2 text-xs-center grey--text">{{messages[0].messaged_day}}</div>
                      <v-flex xs12 v-for="msg in messages" v-if="selectedUserMessages" id="chatWindow" class="pa-0">
                        <v-card class="no-shadow card-r transparent pt-2 pl-2 pb-2 pr-0" v-if="msg.type=='send'">
                          <v-container fluid grid-list-md class="pt-0 pb-0">
                            <v-layout row wrap class="">
                              <v-flex xs10 lg11 class="pb-0 pr-0 pl-0">
                                <v-card class="right transparent no-shadow w-unset" primary-title>
                                  <div class="text-xs-right pa-8p pa-2 darker chat-r-l w-unset">
                                    <div class="text-xs-right f-15 font-weight-medium text-grey word-break">{{msg.message}}</div>
                                  </div>

                                  <!--image upload code-->

                                  <!--<div class="text-xs-right pa-8p darker chat-r-l w-unset w-100">-->
                                  <!--<p class="text-xs-right mb-0 f-15">-->
                                  <!--<img style="object-fit: cover!important;" class="w-100 h-auto" :src="profileImage" alt="avatar">-->
                                  <!--</p>-->
                                  <!--</div>-->
                                  <div class="text-xs-left w-100">
                                    <p class="text-xs-right f-10 font-weight-medium text-grey-light">{{msg.created_at}}</p>
                                  </div>
                                </v-card>
                              </v-flex>
                              <v-flex xs2 lg1 class="pa-0 text-xs-center">
                                <v-avatar class="ma-2":size="50"color="grey lighten-4">
                                  <img class="grey-out-line objec-fit" :src="adminUserImage" alt="avatar">
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                        <v-card  class="no-shadow card-r transparent pt-2 pl-0 pb-2 pr-2" v-if="msg.type=='receive'">
                          <v-container fluid grid-list-md class="pt-0 pb-0">
                            <v-layout row wrap class="">
                              <v-flex xs2 lg1 class="pa-0 text-xs-center">
                                <v-avatar class="ma-2 " :size="50" color="grey lighten-4">
                                  <img class="objec-fit primary-out-line" :src="selecteduserImage" alt="avatar">
                                </v-avatar>
                              </v-flex>
                              <v-flex xs10 lg11 class="pb-0 pr-0 pl-0">
                                <v-card class="left transparent no-shadow w-unset" primary-title>
                                  <div class="text-xs-right pa-8p pa-2 primary chat-r-r w-unset">
                                    <div class="text-xs-left f-15 font-weight-medium text-white word-break">{{msg.message}}</div>
                                  </div>

                                  <!--image upload code-->

                                  <!--<div class="text-xs-right pa-8p darker chat-r-l w-unset w-100">-->
                                  <!--<p class="text-xs-right mb-0 f-15">-->
                                  <!--<img style="object-fit: cover!important;" class="w-100 h-auto" :src="profileImage" alt="avatar">-->
                                  <!--</p>-->
                                  <!--</div>-->
                                  <div class="text-xs-left w-100">
                                    <p class="text-xs-left f-10 font-weight-medium text-grey-light">{{msg.created_at}}</p>
                                  </div>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-container>
                <div>
                  <v-form>
                    <v-container class="">
                      <v-layout row wrap class="">
                        <v-flex xs12 lg12 class="white shadow-1 chat-r-r-r pr-4 pl-2 w-100 card-r chat-box-fix pb-0 f-15 font-weight-medium text-grey">
                          <v-text-field
                            v-model="message"
                            solo
                            placeholder="Text message..."
                            :append-outer-icon="message ? 'send' : ''"
                            type="text"
                            @click:append-outer="sendMessage()"
                            class="pa-0 pt-1 ma-0"
                            required
                          ></v-text-field>
                          <div style="color:red;font-size:11px" v-if="messageAlertMsg">
                            {{messageAlertMsg}} ({{message.length}}/1000)
                          </div>
                        </v-flex>
                        <!--<v-flex xs2 lg1 class="" v-model="message">-->
                          <!--<v-btn flat icon large @click:append-outer="sendMessage()"><v-icon class="text-primary">send</v-icon></v-btn>-->
                          <!--<div style="color:red;font-size:11px" v-if="messageAlertMsg">-->
                            <!--{{messageAlertMsg}} ({{message.length}}/1000)-->
                          <!--</div>-->
                        <!--</v-flex>-->

                      </v-layout>
                    </v-container>
                  </v-form>
                </div>
              </div>

            </v-card>
          </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
  /* eslint-disable */
  import api from "@/utils/backend-api"
  import Pusher from 'pusher-js'
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        items: [
          {active: true, title: 'Adam',sub: "online" , avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg'},
          {active: true, title: 'Mac',sub: "online" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Halina' ,sub: "last online 4min ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Halina' ,sub: "last online 5min ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Halina' ,sub: "last online 7min ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Halina' ,sub: "last online 10min ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Halina' ,sub: "last online 15min ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Halina' ,sub: "last online 55min ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'},
          {active: false, title: 'Petter' ,sub: "last online 10hour ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'}
        ],
        items2: [
          {title: 'Driver School',sub: "last online long time ago" , avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg'}
        ],
        password: 'Password',
        show: false,
        seen: false,
        findtext: false,
        message: 'Hey!',
        marker: true,
        iconIndex: 0,
        icons: [
          'mdi-emoticon',
          'mdi-emoticon-cool',
          'mdi-emoticon-dead',
          'mdi-emoticon-excited',
          'mdi-emoticon-happy',
          'mdi-emoticon-neutral',
          'mdi-emoticon-sad',
          'mdi-emoticon-tongue'
        ],
        items1: [
          {
            message: 'Travis Hoecwfvoiwwcvsdervsdwer we9fhegrgrgf9rghergo eggfrgf ifgf9b ff890f89fg ffhf8f rff8gf8g ward',
            avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
            name: 'Teacher name'
          }
        ],


        chatList:[],
        contactsList:[],
        selectedUserMessages:[],
        selecteduserImage:'',
        selectedUserId:'',
        selectedUserName:'',
        selectedUserlastSeenAgo:'',
        message:'',
        adminUserImage:'',
        messageAlertMsg:'',
        searchValue:'',
        tempChatList:[],
        tempContactList:[],
        todayMessageSent:false
      }
    },
    created:function(){
      this.adminUserImage=Store.state.user.image
      api.postData('admin/getAllMessage')
      .then(res=>{
        this.chatList=res.data.chat
        this.tempChatList=res.data.chat
        this.contactsList=res.data.contact
        this.tempContactList=res.data.contact
      }).catch(err=>{
        // debugger

      })
    },
    watch:{
      chatMessages:function(){
        this.selectedUserMessages=this.chatMessages
      }
    },
    mounted:function(){
        this.pusher=new Pusher('e9455c16bc5f0d6c4547',{
            cluster: 'ap2',
            encrypted: true,
            disableStats: true,
        })
        let pusherToken=Store.state.pusherToken
        this.channel=this.pusher.subscribe(pusherToken);
        this.channel.bind('sendMessagesToUser', function(message) {
          console.log(message);
          let msg={
              message:message.message,
              receiver_id: message.receiver_id,
              receiver_token: message.receiver_token,
              sender_id: message.sender_id,
              sender_image: message.sender_image,
              sender_name: message.sender_name,
              type: "receive",
              created_at:(message.created_at.date).substring(11,19)
            }
            // console.log(this.selectedUserMessages)
            let selectedUserId=Store.state.chatSelectedUserId
            if(selectedUserId==msg.sender_id){
              Store.dispatch('pushChatMessages',{msg})
            }
            // this.selectedUserMessages.push(msg)

        });
    },
    computed: {
      ...mapState([
        'chatMessages'
      ]),

      icon() {
        return this.icons[this.iconIndex]
      }
    },
    methods: {
      searchTeacher(searchValue){
        let chats=this.tempChatList
        let contacts=this.tempContactList
        let searchChatList=[]
        let searchContactList=[]
        chats.forEach(element=>{
          let exist
          if(element.receiver){
            let name=element.receiver.name
            var searchPatt = new RegExp(searchValue,'iu');
            var res = searchPatt.test(name);
            if(res){
                  searchChatList.push(element)
            }
          }else if(element.sender){
            let name=element.sender.name
            var patt = new RegExp(searchValue);
            var res = patt.test(name);
            if(res){
                  searchChatList.push(element)
            }
          }
        })
        this.chatList=searchChatList

        contacts.forEach(element=>{
          let exist
          if(element.receiver){
            let name=element.receiver.name
            var searchPatt = new RegExp(searchValue);
            var res = searchPatt.test(name);
            if(res){
                  searchContactList.push(element)
            }
          }else if(element.sender){
            let name=element.sender.name
            var searchPatt = new RegExp(searchValue);
            var res = searchPatt.test(name);
            if(res){
                  searchContactList.push(element)
            }
          }
        })
        this.contactsList=searchContactList
      },
      GetChats(type,item){
        // debugger
        if(type=='chat'){
          if(item.type=='send'){
            this.selectedUserName=item.receiver.name
            this.selectedUserlastSeenAgo=item.receiver.lastSeenAgo
            this.selectedUserId=item.receiver_id
          }else if(item.type='receive'){
            this.selectedUserName=item.sender.name
            this.selectedUserlastSeenAgo=item.sender.lastSeenAgo
            this.selectedUserId=item.sender_id
          }

        }else if(type=='contact'){
          this.selectedUserName=item.name
          this.selectedUserlastSeenAgo=item.lastSeenAgo
          this.selectedUserId=item.id
        }

        // this.selectedUserName=name
        // this.selectedUserlastSeenAgo=lastSeenAgo
        // this.selectedUserId=id
        let self=this
        api.postData('admin/viewMessage',{user_id:this.selectedUserId})
        .then(res=>{
          if(res.status==200){
              this.selectedUserMessages=res.data
              // let messages=res.data
              // debugger
              let data={
                id:self.selectedUserId,
                messages:res.data
              }
              Store.dispatch('setChatMessages',{data})

              if(res.data[0][0].type=='send'){
                self.selecteduserImage=res.data[0][0].base_url+'/'+res.data[0][0].sender.image
              }else if(res.data[0][0].type=='receive'){
                self.selecteduserImage=res.data[0][0].base_url+'/'+res.data[0][0].receiver.image
              }

          }else{
              this.selectedUserMessages=[]
              Store.dispatch('setEmptyChatMessages')
          }
        }).catch(err=>{
          Store.dispatch('setChatMessages',[])
          this.selectedUserMessages=[]
        })
      },
      toggleMarker() {
        this.marker = !this.marker
      },
      sendMessage() {
          var today = new Date();
          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          if(this.selectedUserMessages.length>0){
            if(this.selectedUserMessages[this.selectedUserMessages.length-1][0].messaged_day=="Today"){
              this.todayMessageSent=true
            }
          }

          if(this.todayMessageSent==false){
            let msg=[{
              message:this.message,
              created_at:time,
              type:'send',
              messaged_date:"Today",
              messaged_day:'Today'
            }]
            this.selectedUserMessages.push(msg)
            this.todayMessageSent=true
          }else if(this.todayMessageSent==true){
            let msg={
              message:this.message,
              created_at:time,
              type:'send',
              messaged_date:date,
              messaged_day:'Today'
            }
            if(this.selectedUserMessages.length>0){
              this.selectedUserMessages[this.selectedUserMessages.length-1].push(msg)
            }else{
              this.selectedUserMessages[this.selectedUserMessages.length].push(msg)
            }
          }


          this.messageAlertMsg=''
          if(this.message.length<=1000){
              // console.log("Hello")
              // var today = new Date();
              // var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
              // var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
              // var dateTime = date+' '+time;
              // let msg={
              //   message:this.message,
              //   created_at:dateTime,
              //   type:'send'
              // }
              // this.selectedUserMessages.push(msg)

              // Store.dispatch('pushChatMessages',{msg})
              // console.log(this.selectedUserMessages)
              api.postData('admin/sendMessage',{user_id:this.selectedUserId,message:this.message})
              .then(res=>{
                  if(res.status==201){

                    this.clearMessage()
                    SaveDataToLocalStorage(data)
                    // setTimeout(()=>{
                      // window.scrollTo(0,document.body.scrollHeight);
                      // var container = this.$el.querySelector("#container")
                      // container.scrollTop = container.scrollHeight
                    // },1000);
                  }
              }).catch(err=>{

              })
              this.resetIcon()
              this.clearMessage()
          }else{
            this.messageAlertMsg="The message may not be greater than 1000 characters."
          }

      },
      clearMessage() {
        this.message = ''
      },
      resetIcon() {
        this.iconIndex = 0
      },
      changeIcon() {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      }
    }
  }

</script>
<style>
  .chat-r-r{
    border-radius: 0px 5px 5px 5px !important
  }
  .chat-r-l{
    border-radius: 5px 0px 5px 5px !important
  }
  .primary-out-line{
    border: 2px solid #0051a0;
  }
  .grey-out-line{
    border: 2px solid #bababa;
  }
  .text-grey{
    color: darkslategray;
  }
  .float-right{
    float: right!important;
  }
  .float-left{
    float: left!important;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .darker {
    border-color: #ccc;
    background-color: #ddd !important;
  }

  .container::after {
    content: "";
    clear: both;
    display: table;
  }

  .coniner img {
    float: left;
    max-width: 40px;
    height: 40px;
    object-fit: cover;
    width: 100%;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: -5px;
    border-radius: 50%;
  }

  .container img.right {
    float: right;
    margin-left: 10px;
    margin-right: 10px;
  }

  .time-right {
    float: right;
    color: #aaa;
  }
  .mr-50{
    margin-right: 50px!important;
  }
  .ml-50{
    margin-left: 50px!important;
  }
  .time-left {
    float: left;
    color: #999;
  }
  .coniner{
    margin-top: 10px;
  }
  /*.v-text-field.v-text-field--enclosed .v-input__prepend-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer {*/
  /*margin-top: 26px!important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/pages/Chat.vue